import { PageButtonProps as IPageButtonProps } from './interface'
import Pagination, { PaginationProps as IPaginationProps } from './pagination'

export type PageButtonProps = IPageButtonProps
export type PaginationProps = IPaginationProps
export { Pagination as default }
